<template>
  <div class="login">
    <div class="is-size-3 login-header">
      {{ $t('authenticator.sign_in_to_account') }}
    </div>
    <div class="field">
      <label class="label is-medium">{{ $t('authenticator.username') }} *</label>
      <div class="control">
        <input
          v-model="$v.user.username.$model"
          class="input is-large"
          type="username"
          autofocus
          :placeholder="$t('authenticator.username_ph')"
        >
      </div>
    </div>
    <div class="field">
      <label class="label is-medium">{{ $t('authenticator.password') }} *</label>
      <div class="control">
        <input
          v-model="$v.user.password.$model"
          class="input is-large"
          type="password"
          :placeholder="$t('authenticator.password_ph')"
        >
      </div>
      <p class="help">
        {{ $t('authenticator.forgot_password') }}
        <a
          href="#"
          @click.prevent="$emit('changeAuthState', $options.REQUIRE_NEW_PASSWORD)"
        >
          {{ $t('authenticator.reset_password') }}
        </a>
      </p>
    </div>
    <div class="field">
      <div class="control">
        <button
          class="button is-primary is-large is-broad is-uppercase"
          :class="{'is-loading': isLoading}"
          @click.prevent="signIn($v)"
        >
          {{ $t('authenticator.sign_in') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { REQUIRE_NEW_PASSWORD, SIGN_UP } from './auth-actions'
import { mapActions, mapGetters } from 'vuex'
import { username, password } from './validation-settings.js'
export default {

  name: 'SignIn',
  props: {
    validationChecks: {
      type: Array,
      default: () => []
    },
    validationRunner: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      user: {
        username: '',
        password: ''
      },
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['ssoRedirect'])
  },
  created () {
    this.$options.REQUIRE_NEW_PASSWORD = REQUIRE_NEW_PASSWORD
    this.$options.SIGN_UP = SIGN_UP
  },
  async mounted () {
    let sso

    if (this.ssoRedirect === null) {
      try {
        sso = new URLSearchParams(window.location.search).get('sso')
      } catch (err) {
        this.$emit('displayError', 'This browser version is not fully supported, please update to the latest version for the best experience.')
        this.$router.history.push('/')
        this.isLoading = false
      }
    } else {
      sso = this.ssoRedirect
      this.setSSORedirect(null)
    }

    if (sso) {
      var username = sso.split('.')[0]
      var token = sso.split('.')[1]

      if (username && username.match(/^ *$/) === null && token && token.match(/^ *$/) === null) {
        this.isLoading = true
        try {
          var data = await this.$auth.signIn(username, null)
            .then(async user => {
              if (user.challengeName === 'CUSTOM_CHALLENGE') {
                return await this.$auth.sendCustomChallengeAnswer(user, token)
              } else {
                console.log(`unexpected challenge: ${user.challengeName}`)
              }
            })
          this.handleSession(data)
          this.$router.history.push('/main')
        } catch (err) {
          this.$emit('displayError', 'Invalid login')
          this.$router.history.push('/')
          this.isLoading = false
        }
      }
    }
  },
  methods: {
    ...mapActions(['handleSession', 'setSSORedirect']),
    async signIn () {
      this.isLoading = true
      this.validationRunner(this.$v, this.validationChecks)

      if (!this.$v.$invalid) {
        try {
          const data = await this.$auth.signIn(
            this.user.username,
            this.user.password
          )
          if (data.challengeName === 'NEW_PASSWORD_REQUIRED') {
            return this.$emit('changeAuthState', this.$options.REQUIRE_NEW_PASSWORD)
          }

          this.handleSession(data)
          this.$router.history.push('/main')
        } catch (err) {
          this.handleSession(null)
          this.$emit('displayError', err.message)
        }
      }
      this.isLoading = false
    }
  },
  validations: {
    user: {
      username,
      password
    }
  }

}
</script>
